module.exports = __webpack_public_path__ + "static/img/user-pick-propmotion-banner-betting-slip.8892512.png";